<template>
    <div class="personal-info">
        <div>
            <div class="shadow">
                <div style="display: flex;align-items: flex-end;">
                    <span class="d-title">个人信息</span>
                    <span style="flex: 1;text-align: right;" class="d-edit" @click="isEdit = !isEdit">编辑</span>
                </div>
                <div style="margin-top: 0.2rem;">
                    <div style="background-color: #909399;height: 1px;width: 100%;"></div>
                </div>
                <div style="margin-top: 0.2rem;" id="b-content">
                    <div v-if="!isEdit" style="padding: 0.1rem 0 0.1rem 0;">
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">身份证姓名:</el-col>
                            <el-col :span="7" class="col-n col">{{ personalInfoForm.name }}</el-col>
                            <el-col :span="5" class="col">证件号码:</el-col>
                            <el-col :span="7" class="col-n col">{{ personalInfoForm.id_no }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">出生日期:</el-col>
                            <el-col :span="7" class="col-n col">{{ personalInfoForm.birthday }}</el-col>
                            <el-col :span="5" class="col">年龄<el-tooltip effect="dark" content="系统根据「出生日期」自动计算"
                                    placement="top">
                                    <i class="el-icon-info" style="color: #F56C6C;"></i>
                                </el-tooltip>:</el-col>
                            <el-col :span="7" class="col-n col">{{ base.age }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">性别:</el-col>
                            <el-col :span="7" class="col-n col" v-if="personalInfoForm.sex === 0">女</el-col>
                            <el-col :span="7" class="col-n col" v-else-if="personalInfoForm.sex === 1">男</el-col>
                            <el-col :span="7" class="col-n col" v-else></el-col>
                            <el-col :span="5" class="col">民族:</el-col>
                            <el-col :span="7" class="col-n col">{{ nation }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">身份证地址:</el-col>
                            <el-col :span="7" class="col-n col">{{ personalInfoForm.id_address }}</el-col>
                            <el-col :span="5" class="col">证件有效期:</el-col>
                            <el-col :span="7" class="col-n col" v-if="personalInfoForm.id_is_no_limit !== true">{{ personalInfoForm.id_validity }}</el-col>
                            <el-col :span="7" class="col-n col" v-else="personalInfoForm.id_is_no_limit !== true">长期</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">户籍类型:</el-col>
                            <el-col :span="7" class="col-n col">{{ residence_type }}</el-col>
                            <el-col :span="5" class="col">住址:</el-col>
                            <el-col :span="7" class="col-n col">{{ personalInfoForm.adress }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">政治面貌:</el-col>
                            <el-col :span="7" class="col-n col">{{ political_outlook }}</el-col>
                            <el-col :span="5" class="col">婚姻状况:</el-col>
                            <el-col :span="7" class="col-n col">{{ marital_status }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">首次参加工作时间:</el-col>
                            <el-col :span="7" class="col-n col">{{ personalInfoForm.first_time_working }}</el-col>
                            <el-col :span="5" class="col">工龄(年)<el-tooltip effect="dark" content="系统根据「首次参加工作时间」自动计算"
                                    placement="top">
                                    <i class="el-icon-info" style="color: #F56C6C;"></i>
                                </el-tooltip>:</el-col>
                            <el-col :span="7" class="col-n col">{{ base.working_age }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">个人社保账号:</el-col>
                            <el-col :span="7" class="col-n col">{{ personalInfoForm.personal_social_security_account }}</el-col>
                            <el-col :span="5" class="col">个人公积金账号:</el-col>
                            <el-col :span="7" class="col-n col">{{ personalInfoForm.personal_provident_fund_account }}</el-col>
                        </el-row>
                    </div>
                    <div v-else>
                        <el-form ref="personalInfoForm" :model="personalInfoForm" label-width="125px" size="medium">
                            <el-form-item label="身份证姓名">
                                <el-input v-model.trim="personalInfoForm.name" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="证件号码">
                                <el-input v-model.trim="personalInfoForm.id_no" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="出生日期">
                                <el-date-picker v-model="personalInfoForm.birthday" type="date" unlink-panels
                                    value-format="yyyy-MM-dd" style="width: 100%" size="medium">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="性别">
                                <el-select v-model="personalInfoForm.sex" placeholder="请选择" style="width: 100%" clearable
                                    filterable size="medium">
                                    <el-option :value="0" label="女">
                                        女
                                    </el-option>
                                    <el-option :value="1" label="男">
                                        男
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="民族">
                                <el-select @click.native="ysyMGetAboutNation" v-model="personalInfoForm.nation"
                                    placeholder="请选择" style="width: 100%" clearable filterable size="medium">
                                    <el-option :value="item.id" :label="item.name" v-for="item in ysyMAboutNationOptions"
                                        :key="item.id">
                                        {{ item.name }}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="身份证地址">
                                <el-input v-model.trim="personalInfoForm.id_address" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="证件有效期">
                                <div style="white-space: nowrap;">
                                    <el-date-picker v-model="personalInfoForm.id_validity" type="date" unlink-panels
                                        value-format="yyyy-MM-dd" style="width: 68%" size="medium"
                                        @change="clearIsNoLimitChecked">
                                    </el-date-picker>
                                    <el-checkbox v-model="personalInfoForm.id_is_no_limit"
                                        style="display: inline-block;margin-left: 0.2rem;" @change="clearIdValidity">长期
                                    </el-checkbox>
                                </div>
                            </el-form-item>
                            <el-form-item label="户籍类型">
                                <el-select v-model="personalInfoForm.residence_type" placeholder="请选择" style="width: 100%"
                                    clearable filterable size="medium">
                                    <el-option :value="1" label="本地城镇">
                                        本地城镇
                                    </el-option>
                                    <el-option :value="2" label="本地农村">
                                        本地农村
                                    </el-option>
                                    <el-option :value="3" label="外地城镇(省内)">
                                        外地城镇(省内)
                                    </el-option>
                                    <el-option :value="4" label="外地农村(省内)">
                                        外地农村(省内)
                                    </el-option>
                                    <el-option :value="5" label="外地城镇(省外)">
                                        外地城镇(省外)
                                    </el-option>
                                    <el-option :value="6" label="外地农村(省外)">
                                        外地农村(省外)
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="住址">
                                <el-input v-model.trim="personalInfoForm.adress" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="政治面貌">
                                <el-select v-model="personalInfoForm.political_outlook" placeholder="请选择"
                                    style="width: 100%" clearable filterable size="medium">
                                    <el-option :value="1" label="团员">
                                        团员
                                    </el-option>
                                    <el-option :value="2" label="党员">
                                        党员
                                    </el-option>
                                    <el-option :value="3" label="群众">
                                        群众
                                    </el-option>
                                    <el-option :value="4" label="其他">
                                        其他
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="婚姻状况">
                                <el-select v-model="personalInfoForm.marital_status" placeholder="请选择" style="width: 100%"
                                    clearable filterable size="medium">
                                    <el-option :value="1" label="未婚">
                                        未婚
                                    </el-option>
                                    <el-option :value="2" label="已婚">
                                        已婚
                                    </el-option>
                                    <el-option :value="3" label="离异">
                                        离异
                                    </el-option>
                                    <el-option :value="4" label="丧偶">
                                        丧偶
                                    </el-option>
                                    <el-option :value="5" label="分居">
                                        分居
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="首次参加工作时间">
                                <el-date-picker v-model="personalInfoForm.first_time_working" type="date" unlink-panels
                                    value-format="yyyy-MM-dd" style="width: 100%" size="medium">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="个人社保账号">
                                <el-input v-model.trim="personalInfoForm.personal_social_security_account"
                                    clearable></el-input>
                            </el-form-item>
                            <el-form-item label="个人公积金账号">
                                <el-input v-model.trim="personalInfoForm.personal_provident_fund_account"
                                    clearable></el-input>
                            </el-form-item>
                            <el-form-item size="medium">
                                <el-button type="primary" @click="onSubmit">提交</el-button>
                                <el-button @click.native="isEdit = !isEdit">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { common } from '../../../../static/mixins/common'
export default {
    name: 'PersonalInfo',
    mixins: [common],
    props: {
        adminuser_id: {
            type: Number
        },
        adminuser_name: {
            type: String
        }
    },
    data() {
        return {
            personalInfoForm: {
                name: '',
                id_no: '',
                birthday: '',
                sex: '',
                nation: '',
                id_address: '',
                id_validity: '',
                id_is_no_limit: false,
                residence_type: '',
                adress: '',
                political_outlook: '',
                marital_status: '',
                first_time_working: '',
                personal_social_security_account: '',
                personal_provident_fund_account: ''
            },
            isEdit: false,
            adminuserId: '',
            adminuserName: '',
            base: {
                age: '',
                working_age: '',
            },
        }
    },
    methods: {
        onSubmit() {
            this.personalInfoForm.admin_user_id = this.adminuserId
            this.$axios.put('api/api3_update_personalinfo', this.personalInfoForm).then(({ data }) => {
                if (data.code === 200) {
                    this.base.age = data.data['age']
                    this.base.working_age = data.data['working_age']
                    this.$message.success(data.msg)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        getAdminUserPersonalInfo(admin_user_id) {
            this.resetForm()
            this.ysyMAboutNationOptions = []
            this.ysyMGetAboutNation()
            this.ysyMAdminUserPersonalInfoOptions = []
            this.ysyMGetAdminUserPersonalInfo(admin_user_id)
        },
        resetForm() {
            this.personalInfoForm.name = ''
            this.personalInfoForm.id_no = ''
            this.personalInfoForm.birthday = ''
            this.personalInfoForm.sex = ''
            this.personalInfoForm.nation = ''
            this.personalInfoForm.id_address = ''
            this.personalInfoForm.id_validity = ''
            this.personalInfoForm.id_is_no_limit = false
            this.personalInfoForm.residence_type = ''
            this.personalInfoForm.adress = ''
            this.personalInfoForm.political_outlook = ''
            this.personalInfoForm.marital_status = ''
            this.personalInfoForm.first_time_working = ''
            this.personalInfoForm.personal_social_security_account = '',
                this.personalInfoForm.personal_provident_fund_account = ''

            this.base.age = ''
            this.base.working_age = ''
        },
        clearIsNoLimitChecked(val) {
            if (val) {
                this.personalInfoForm.id_is_no_limit = false
            }
        },
        clearIdValidity(val) {
            if (val) {
                this.personalInfoForm.id_validity = ''
            }
        }
    },
    watch: {
        adminuser_id: {
            immediate: true,
            handler(n, o) {
                this.adminuserId = null
                if (n !== o) {
                    this.adminuserId = n
                    this.getAdminUserPersonalInfo(n)
                }
            }
        },
        adminuser_name: {
            immediate: true,
            handler(n, o) {
                if (n !== o) {
                    this.adminuserName = n
                }
            }
        },
        ysyMAdminUserPersonalInfoOptions: {
            handler(n, o) {
                if (n !== o) {
                    if (n) {
                        if (n.admin_user) {
                            this.personalInfoForm.sex = n.admin_user.sex
                        }
                        this.personalInfoForm.name = n.name
                        this.personalInfoForm.id_no = n.id_no
                        this.personalInfoForm.birthday = n.birthday
                        this.base.age = n.age
                        this.personalInfoForm.nation = n.nation
                        this.personalInfoForm.id_address = n.id_address
                        this.personalInfoForm.id_validity = n.id_validity
                        this.personalInfoForm.id_is_no_limit = n.id_is_no_limit === 1 ? true:false
                        this.personalInfoForm.residence_type = n.residence_type
                        this.personalInfoForm.adress = n.adress
                        this.personalInfoForm.political_outlook = n.political_outlook
                        this.personalInfoForm.marital_status = n.marital_status
                        this.personalInfoForm.first_time_working = n.first_time_working
                        this.base.working_age = n.working_age
                        this.personalInfoForm.personal_social_security_account = n.personal_social_security_account
                        this.personalInfoForm.personal_provident_fund_account = n.personal_provident_fund_account
                    }
                }
            },
        },
    },
    computed: {
        nation() {
            let name = null
            this.ysyMAboutNationOptions.map(item => {
                if (item.id === this.personalInfoForm.nation) {
                    name = item.name
                }
            })
            return name
        },
        residence_type() {
            let residence_type_arr = ['本地城镇','本地农村','外地城镇(省内)','外地农村(省内)','外地城镇(省外)','外地农村(省外)']
            return residence_type_arr[this.personalInfoForm.residence_type - 1]
        },
        political_outlook() {
            let political_outlook_arr = ['团员','党员','群众','其他']
            return political_outlook_arr[this.personalInfoForm.political_outlook - 1]
        },
        marital_status() {
            let marital_status_arr = ['未婚','已婚','离异','丧偶','分居']
            return marital_status_arr[this.personalInfoForm.marital_status - 1]
        }
    }
}
</script>

<style scoped>
.d-title {
    font-size: x-large;
    font-weight: bold;
}

.d-edit {
    font-size: medium;
    font-weight: bold;
    color: #409EFF;
    cursor: pointer;
}

/* .col {
    font-size: larger;
    font-weight: bold;
} */

/* .col-n {
    color: slategrey;
} */

#b-content .el-row {
    margin-bottom: 0.6rem;
}

.shadow {
    padding: 0.3rem 0.6rem;
    border: 1px solid #ccc;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .3);
    margin: 0.2rem;
}

.over-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#b-content>>>.el-form-item {
    width: 45% !important;
    display: inline-block !important;
}</style>


// WEBPACK FOOTER //
// src/pages/authority/UserInfoTab/PersonalInfo.vue